import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-muted-foreground flex flex-col items-center gap-3 pt-5 text-center text-xs"
}

import { Button } from '@/components/ui/button';
    import { computed, watch, ref } from 'vue';
    import { CreditCard, Pencil } from 'lucide-vue-next';
    import { router, usePage } from '@inertiajs/vue3';
    import { SectionHeader } from '@/components/ui/form';
    import { SharedData } from '@/types';
    import { useCompanyClientData } from '@/composables/useCompanyClientData';
    import { useCustomerEmployeeData } from '@/composables/useCustomerEmployeeData';
    import { useI18n } from 'vue-i18n';
    import { useVoucherAssignmentData } from '@/composables/useVoucherAssignmentData';
    import { dedupeAssigneeIds, splitAssigneeIds, toAssigneeIds } from '@/utils/voucherAssignees';
    import VoucherAdministrateCardsForm from './VoucherAdministrateCardsForm.vue';
    import VoucherAdministrateFallbackForm from './VoucherAdministrateFallbackForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAdministrateContent',
  props: {
    form: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { voucherAssignmentData } = useVoucherAssignmentData(selectedCompanyId.value);
    const { customerEmployees } = useCustomerEmployeeData(selectedCompanyId.value);
    const { clientOptions, isPendingClientOptions } = useCompanyClientData(selectedCompanyId.value);

    const { t } = useI18n();

    const props = __props;

    const fallbackForm = ref<any>(null);

    watch([voucherAssignmentData, customerEmployees], ([newVal]) => {
        if (!newVal) {
            return;
        }

        const employees = customerEmployees.value ?? [];

        props.form.cards = JSON.parse(JSON.stringify(newVal.credit_cards));

        const fallbackAssigneeIds = dedupeAssigneeIds(
            toAssigneeIds(
                newVal.voucher_assigned_fallback ?? [],
                newVal.voucher_assigned_fallback_users ?? [],
                employees,
            ),
            employees,
        );
        const fallbackAssignees = splitAssigneeIds(fallbackAssigneeIds);
        props.form.fallback_assignee_ids = fallbackAssigneeIds;
        props.form.fallback_employee_ids = fallbackAssignees.employee_ids;
        props.form.fallback_user_ids = fallbackAssignees.user_ids;

        props.form.voucher_assignment_rules = JSON.parse(
            JSON.stringify(newVal.voucher_assignment_rules),
        ).map((rule: { employee_ids?: number[]; user_ids?: number[] }) => {
            const assigneeIds = dedupeAssigneeIds(
                toAssigneeIds(rule.employee_ids ?? [], rule.user_ids ?? [], employees),
                employees,
            );
            const assignees = splitAssigneeIds(assigneeIds);

            return {
                ...rule,
                employee_ids: assignees.employee_ids,
                user_ids: assignees.user_ids,
                assignee_ids: assigneeIds,
            };
        });

        if (props.form.voucher_assignment_rules.length === 0) {
            fallbackForm.value?.addVoucherAssignmentRule();
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(SectionHeader), { class: "flex-col justify-between sm:flex-row" }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('vouchers.administrate.subtitle')), 1),
        _createVNode(_unref(Button), {
          variant: "ghost_warning",
          size: "none",
          class: "text-xs",
          tabindex: "-1",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).visit(_ctx.route('v2.credit-cards.index'))), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('vouchers.administrate.administrate_cards')) + " ", 1),
            _createVNode(_unref(Pencil), { class: "text-warning size-3" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.form.cards.length > 0)
      ? (_openBlock(), _createBlock(VoucherAdministrateCardsForm, {
          key: 0,
          form: _ctx.form,
          "employee-options": _unref(customerEmployees),
          "user-options": _unref(clientOptions),
          "is-loading-user-options": _unref(isPendingClientOptions)
        }, null, 8, ["form", "employee-options", "user-options", "is-loading-user-options"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(CreditCard)),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('vouchers.administrate.no_cards')), 1)
        ])),
    _createVNode(_unref(SectionHeader), { class: "flex-col justify-between sm:flex-row" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('vouchers.administrate.general')), 1)
      ]),
      _: 1
    }),
    _createVNode(VoucherAdministrateFallbackForm, {
      ref_key: "fallbackForm",
      ref: fallbackForm,
      form: _ctx.form
    }, null, 8, ["form"])
  ], 64))
}
}

})